const toInt = (value) => (value !== undefined && value !== '' ? parseInt(value, 10) : undefined);
const toBool = (value) => (value !== undefined ? value === 'true' || value === '1' : undefined);

const config = {
  // API配置
  api: {
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: toInt(process.env.REACT_APP_API_TIMEOUT),
    headers: process.env.REACT_APP_API_HEADERS ? JSON.parse(process.env.REACT_APP_API_HEADERS) : undefined
  },
  
  // 应用配置
  app: {
    name: process.env.REACT_APP_NAME,
    version: process.env.REACT_APP_VERSION,
    environment: process.env.NODE_ENV
  },
  
  // 本地存储键名
  storage: {
    token: process.env.REACT_APP_STORAGE_TOKEN,
    userId: process.env.REACT_APP_STORAGE_USER_ID,
    isAdmin: process.env.REACT_APP_STORAGE_IS_ADMIN
  },
  
  // 时区配置
  timezone: {
    frontend: process.env.REACT_APP_TIMEZONE
  },
  
  // 功能开关
  features: {
    googleAuth: toBool(process.env.REACT_APP_GOOGLE_AUTH_ENABLED),
    aiChat: toBool(process.env.REACT_APP_AI_CHAT_ENABLED),
    monitoring: toBool(process.env.REACT_APP_MONITORING_ENABLED)
  },
  
  // 开发配置
  development: {
    debugMode: toBool(process.env.REACT_APP_DEBUG_MODE),
    verboseLogging: toBool(process.env.REACT_APP_VERBOSE_LOGGING)
  },
  
  // 服务器配置
  server: {
    port: toInt(process.env.REACT_APP_PORT),
    host: process.env.REACT_APP_HOST
  },
  
  // 构建配置
  build: {
    outputDir: process.env.REACT_APP_BUILD_DIR,
    publicUrl: process.env.REACT_APP_PUBLIC_URL
  },
  
  // UI配置
  ui: {
    theme: process.env.REACT_APP_THEME,
    language: process.env.REACT_APP_LANGUAGE
  },
  
  // 性能配置
  performance: {
    serviceWorker: toBool(process.env.REACT_APP_SERVICE_WORKER_ENABLED),
    pwa: toBool(process.env.REACT_APP_PWA_ENABLED),
    // 移动端优化
    mobile: {
      lazyLoading: toBool(process.env.REACT_APP_MOBILE_LAZY_LOADING),
      imageOptimization: toBool(process.env.REACT_APP_MOBILE_IMAGE_OPTIMIZATION),
      bundleSplitting: toBool(process.env.REACT_APP_MOBILE_BUNDLE_SPLITTING),
      compression: toBool(process.env.REACT_APP_MOBILE_COMPRESSION)
    }
  },
  
  // 安全配置
  security: {
    csp: toBool(process.env.REACT_APP_CSP_ENABLED),
    httpsOnly: toBool(process.env.REACT_APP_HTTPS_ONLY)
  }
};

export default config; 